(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('help', {
            parent: 'site',
            url: '/help',
            data: {
                pageTitle: 'global.menu.help'
            },
            views: {
                'content@': {
                    templateUrl: 'app/views/help/help.html',
                    controller: 'HelpController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('help');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
